import {AfterViewInit, Component} from '@angular/core';
import {ControlService, IconService, SubtitlesService} from "../../../core";
import {MenuType} from "../../../models";

@Component({
    selector: 'group-code',
    templateUrl: './group-code.component.html',
    styleUrls: ['./group-code.component.scss']
})
export class GroupCodeComponent implements AfterViewInit {
    constructor(
        public control: ControlService,
        private icon: IconService,
        private subtitles: SubtitlesService,
    ) {
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }
}
